import React from 'react'
import './SelfScheduleButton.scss'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { MODULE_KEYS, SELF_SCHEDULING_DEFAULTS } from '../../moduleRegistry'

interface SelfScheduleButtonProps {
  onClick?: () => void
  disabled?: boolean
}

function SelfScheduleButton ({ onClick, disabled }: SelfScheduleButtonProps) {
  const { scheduleButtonCardCTA } = useModuleConfig(MODULE_KEYS.selfScheduling, SELF_SCHEDULING_DEFAULTS)
  return <button className="self_schedule_button" onClick={onClick} disabled={disabled}>
    {scheduleButtonCardCTA}
  </button>
}

export default SelfScheduleButton
